export default __webpack_public_path__ + "static/media/nature.ef941402.jpg";